import styled from 'styled-components'

export const Btn = styled.button`
    background-color: #6558f5
    border: none;
    padding: 10px;
    border-radius: 5px;
    color: white;

    &:hover {
        cursor: pointer;
        opacity: 0.8;
    }
`;